import Class from './c-date-nav';
import './c-date-nav@';

export default Class;